import axios from "axios";

axios.defaults.baseURL = "https://dev-connector-app.onrender.com"; // replace with your backend URL

export default axios;
